import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Assessment, Bolt, CheckCircle, Speed } from '@mui/icons-material';

import { colors } from '../../theme';
import { Tile } from './primitives';

function SummaryTiles({ filteredCount, totalCount, highConfidence, actionable, avgScore, t }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(2, minmax(0, 1fr))',
          lg: 'repeat(4, minmax(0, 1fr))',
        },
        gap: 1.5,
      }}
    >
      <Tile
        label={t('ichimokuTransition.tiles.total')}
        value={filteredCount}
        sub={`${t('ichimokuTransition.tiles.fromUniverse')}: ${totalCount}`}
        color={colors.gray[800]}
        Icon={Assessment}
      />
      <Tile
        label={t('ichimokuTransition.tiles.highConfidence')}
        value={highConfidence}
        sub={t('ichimokuTransition.tiles.highConfidenceSub')}
        color={colors.success.main}
        Icon={CheckCircle}
      />
      <Tile
        label={t('ichimokuTransition.tiles.actionable')}
        value={actionable}
        sub={t('ichimokuTransition.tiles.actionableSub')}
        color={colors.info.main}
        Icon={Bolt}
      />
      <Tile
        label={t('ichimokuTransition.tiles.avgScore')}
        value={avgScore}
        sub={t('ichimokuTransition.tiles.avgScoreSub')}
        color={colors.warning.main}
        Icon={Speed}
      />
    </Box>
  );
}

SummaryTiles.propTypes = {
  filteredCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  highConfidence: PropTypes.number.isRequired,
  actionable: PropTypes.number.isRequired,
  avgScore: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default SummaryTiles;
